
















import { defineComponent } from '@vue/composition-api';
import { useRouter } from '../../router';
import PrivacyPolicyEN from './privacy-en.md';
import PrivacyPolicyIT from './privacy-it.md';
import PrivacyPolicyDE from './privacy-de.md';
import PrivacyPolicyES from './privacy-es.md';
import PrivacyPolicyFR from './privacy-fr.md';
import PrivacyPolicyPT from './privacy-pt.md';

const componentName = 'PrivacyPolicy';

export default defineComponent({
    name: componentName,
    
    setup(context) {
        const { router, route } = useRouter();

        let language = 'en';
        if (route.value.query.returnUrl) {
            const params = new URLSearchParams(route.value.query.returnUrl as string);
            if (params) {
                language = params.get('language') ?? 'en';
            }
        }
        
        let markdownContent = PrivacyPolicyEN;
        switch (language) {
            case 'it':
                markdownContent = PrivacyPolicyIT;
                break;
            case 'en':
                markdownContent = PrivacyPolicyEN;
                break;
            case 'de':
                markdownContent = PrivacyPolicyDE;
                break;
            case 'fr':
                markdownContent = PrivacyPolicyFR;
                break;
            case 'es':
                markdownContent = PrivacyPolicyES;
                break;
            case 'pt':
                markdownContent = PrivacyPolicyPT;
                break;
        }

        return {
            markdownContent,
        }
    }
})
